<div class="customer-branding-wrapper" *ngIf="showTab$ | async">
  <div class="row">
    <div class="col-12">
      <h3 translate>CUSTOMER_BRANDING</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-4">
      <input
        type="text"
        class="form-control mb-2"
        placeholder="{{ 'SEARCH' | translate }}"
        (input)="filter($event.target.value)"
      />
      <ul class="list-group" style="max-height: 70vh; overflow-y: auto;">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
          *ngFor="let group of filteredGroups"
          [class.active]="group === selectedGroup"
          (click)="selectGroup(group)"
          style="cursor: pointer;"
        >
          <span>{{ group | translate }}</span>
          <span class="badge bg-primary rounded-pill" *ngIf="hasBranding(group)">&#9679;</span>
        </li>
      </ul>
    </div>

    <div class="col-12 col-md-8" *ngIf="branding">
      <!-- THEME colours -->
      <h3 translate>COLOR</h3>
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="d-flex align-items-end">
            <lib-gung-color-input
              gungTranslate="PRIMARY_COLOR"
              [(ngModel)]="branding.colors.primary"
            ></lib-gung-color-input>
          </div>
          <div class="d-flex align-items-end">
            <lib-gung-color-input
              gungTranslate="SECONDARY_COLOR"
              [(ngModel)]="branding.colors.secondary"
            ></lib-gung-color-input>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="d-flex align-items-end">
            <lib-gung-color-input gungTranslate="HOVER_COLOR" [(ngModel)]="branding.colors.hover"></lib-gung-color-input>
          </div>
          <div class="d-flex align-items-end">
            <lib-gung-color-input
              gungTranslate="CONTRASTING_COLOR"
              [(ngModel)]="branding.colors.contrasting"
            ></lib-gung-color-input>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="d-flex align-items-end">
            <lib-gung-color-input
              gungTranslate="NAVBAR_COLOR"
              [(ngModel)]="branding.colors.navbarcolor"
            ></lib-gung-color-input>
          </div>
          <div class="d-flex align-items-end">
            <lib-gung-color-input
              gungTranslate="NAVBAR_FONT_COLOR"
              [(ngModel)]="branding.colors.navbarfontcolor"
            ></lib-gung-color-input>
          </div>
          <div class="d-flex align-items-end">
            <lib-gung-color-input
              gungTranslate="NAVBAR_FONT_HOVER_COLOR"
              [(ngModel)]="branding.colors.navbarfonthovercolor"
            ></lib-gung-color-input>
          </div>
        </div>
      </div>

      <hr />

      <!-- Navbar logo -->
      <h5 class="mt-2" translate>CUSTOMIZE_NAVBAR_LOGO</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 my-3">
          <lib-gung-input-file
            accept="image/*"
            multiple="true"
            enableDragDrop="true"
            (onFileSelect)="onLogoSelect($event)"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-8">
          <div *ngIf="objectFileImagePreview['logo'] as logoPreview" class="position-relative text-center">
            <button
              type="button"
              class="btn btn-danger btn-sm position-absolute"
              style="top: 0; right: 0; z-index: 2;"
              (click)="removeLogo()"
              translate
            >
              REMOVE_IMAGE
            </button>
            <!-- s3Uri is an S3 key, not a URL — it must go through gungImageUrl to resolve to the CDN
                 (same as My Company). Only a local data-URL preview has no s3ETag and renders as-is. -->
            @if (logoPreview.s3ETag) {
              <img
                class="img-fluid"
                style="max-height: 150px;"
                [src]="logoPreview.s3Uri | gungImageUrl : 'etag:' + logoPreview.s3ETag : 'type:thumbnail' : 'size:800x500'"
                alt="{{ logoPreview.name }}"
              />
            } @else {
              <img class="img-fluid" style="max-height: 150px;" [src]="logoPreview.s3Uri" alt="{{ logoPreview.name }}" />
            }
          </div>
        </div>
      </div>

      <hr />

      <!-- Navbar banner -->
      <h3 translate>NAVBAR_BANNER</h3>
      <div class="row" *ngIf="branding.extra?.navbarBanner as navbarBanner">
        <div class="col-12 col-sm-4">
          <lib-gung-checkbox-input-horizontal
            gungTranslate="ENABLE"
            [(ngModel)]="navbarBanner.enabled"
          />
        </div>

        <ng-container *ngIf="navbarBanner.enabled">
          <div class="col-12">
            <lib-gung-text-input gungTranslate="TEXT" [(ngModel)]="navbarBanner.text"></lib-gung-text-input>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <lib-gung-select-option-input
              gungTranslate="TEXT_STYLE"
              [optionsList]="textFormattingOptionList"
              [(ngModel)]="navbarBanner.textFormatting"
              [showId]="false"
            />
          </div>

          <div class="col-12 col-md-6 mt-2">
            <lib-gung-select-option-input
              gungTranslate="BANNER_HEIGHT"
              [optionsList]="bannerHeightOptionList"
              [(ngModel)]="navbarBanner.bannerHeight"
              [showId]="false"
            />
          </div>

          <div class="col-12 col-md-6 mt-2">
            <div class="d-flex align-items-end">
              <lib-gung-color-input
                gungTranslate="BACKGROUND"
                [(ngModel)]="navbarBanner.backgroundColor"
              ></lib-gung-color-input>
            </div>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <div class="d-flex align-items-end">
              <lib-gung-color-input gungTranslate="TEXT_COLOR" [(ngModel)]="navbarBanner.textColor"></lib-gung-color-input>
            </div>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <lib-gung-checkbox-input-horizontal gungTranslate="CENTER_TEXT" [(ngModel)]="navbarBanner.centerText" />
          </div>

          <div class="col-12 mt-2">
            <h5 translate>IMAGE</h5>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 my-3">
                <lib-gung-input-file
                  accept="image/*"
                  multiple="true"
                  enableDragDrop="true"
                  (onFileSelect)="onBannerImageSelect($event)"
                />
              </div>
              <div class="col-12 col-md-6 col-lg-8">
                <div
                  *ngIf="objectFileImagePreview['extra.navbarBanner.navbarBannerImage'] as bannerPreview"
                  class="position-relative text-center"
                >
                  <button
                    type="button"
                    class="btn btn-danger btn-sm position-absolute"
                    style="top: 0; right: 0; z-index: 2;"
                    (click)="removeBannerImage()"
                    translate
                  >
                    REMOVE_IMAGE
                  </button>
                  @if (bannerPreview.s3ETag) {
                    <img
                      class="img-fluid"
                      style="max-height: 150px;"
                      [src]="bannerPreview.s3Uri | gungImageUrl : 'etag:' + bannerPreview.s3ETag : 'type:thumbnail' : 'size:800x500'"
                      alt="{{ bannerPreview.name }}"
                    />
                  } @else {
                    <img
                      class="img-fluid"
                      style="max-height: 150px;"
                      [src]="bannerPreview.s3Uri"
                      alt="{{ bannerPreview.name }}"
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row mt-3">
        <div class="col-12 text-right">
          <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
            {{ 'SAVE' | translate }}
            <i *ngIf="saving" class="fa fa-spinner fa-spin ml-2" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
